module.exports = __webpack_public_path__ + "static/media/preAuditStandardTemplate.a95f7dd1.xlsx";